import { createFileRoute } from "@tanstack/react-router";
import { AuthGate } from "@/components/AuthGate";
import { useAuth } from "@/hooks/use-auth";
import { useTheme, THEMES } from "@/hooks/use-theme";
import { PageContainer } from "@/components/PageContainer";
import { Eyebrow, DisplayHeading } from "@/components/editorial";

export const Route = createFileRoute("/settings")({
  head: () => ({
    meta: [
      { title: "Settings — Tiger's Eye" },
      { name: "description", content: "Account settings for your Tiger's Eye Academic Review profile." },
      { name: "robots", content: "noindex,follow" },
    ],
  }),
  component: () => (<AuthGate><Settings /></AuthGate>),
});

function Settings() {
  const { user } = useAuth();
  const { theme, setTheme, mode, setMode } = useTheme();
  return (
    <PageContainer>
      <Eyebrow className="mb-3">Account</Eyebrow>
      <DisplayHeading level={1} className="mb-8">Settings</DisplayHeading>
      <div className="border border-rule bg-card p-6 space-y-2">
        <Eyebrow>Signed in as</Eyebrow>
        <p className="font-serif text-2xl text-primary">{user?.email}</p>
        <p className="text-sm text-ink-tertiary">User ID: <span className="font-mono">{user?.id}</span></p>
      </div>

      <div className="border border-rule bg-card p-6 space-y-4 mt-6">
        <Eyebrow>Appearance</Eyebrow>

        <div className="space-y-2">
          <label htmlFor="theme-select" className="block text-sm font-medium text-ink-secondary">
            Colour scheme
          </label>
          <select
            id="theme-select"
            value={theme}
            onChange={(e) => setTheme(e.target.value as typeof theme)}
            className="w-full max-w-xs rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {THEMES.map((t) => (
              <option key={t.id} value={t.id}>{t.label}</option>
            ))}
          </select>
        </div>

        <div className="space-y-2">
          <label htmlFor="mode-select" className="block text-sm font-medium text-ink-secondary">
            Mode
          </label>
          <select
            id="mode-select"
            value={mode}
            onChange={(e) => setMode(e.target.value as typeof mode)}
            className="w-full max-w-xs rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </div>
      </div>
    </PageContainer>
  );
}
